import { createFileRoute } from "@tanstack/react-router";
import { Unsubscribe } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/unsubscribe")({
  head: () => seoHead({ title: "Email preferences", noindex: true }),
  component: Unsubscribe,
});
